import React, { Component, Fragment } from 'react'
import { addAttachmentIcon, openStepAlertsIcon, closeStepAlertsIcon, timeEstimationIcon, 
    timeEstimationNoToolTip, requireVerification, noVerification, noOversight, requiresOversightIcon, stepNameField, stepContentIcon, 
    countStepAlerts, tocToggleIcon,  lastStepActive, lastStepInactive, nextStep, finishTask, AttachmentArrowRightNav,AttachmentArrowLeftNav,AttachmentArrowLeftDisabledNav } from "../../../../Templates/icons"
import EditStepNameFieldContainer from './edit_step_name_field_container'
import TimeEstimations from './TimeEstimations'
import NavigationButtons from '../../Preview/NavigationButtons'
import ModelAnnotationButton from '../ModelAnnotation/ModelAnnotation'
import { findExtension,isModel } from '../../../../Templates/functions'
import { cloneDeep, isEmpty, isEqual} from 'lodash'
class StepActionsToolbar extends Component {
    state = {
        editingTime: false,
        modelAnnotationButtonDisabled:true
    }

    componentDidMount = () =>{
        let display = document.getElementById("webGL-window")
        {display? display.addEventListener("click",this.checkisModelAnnotationLoaded): console.log("Unable to set click listener for webgl")}
    }

    componentDidUpdate(prevProps) {
        if(!isEqual(this.props.selectedStep, prevProps.selectedStep)) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
        {
            console.log("step changed");
            this.renderModelAnnotationIcon();
        }
    
        if(!isEqual(this.props.attachmentIndex, prevProps.attachmentIndex)) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
        {
            console.log("attachment changed");
            this.renderModelAnnotationIcon();
        }
    } 

    checkisModelAnnotationLoaded =(event) =>{
       // alert("test")
       // if(!this.props.toggleAnnotation){
        //     alert("test")
            //     event.preventDefault();
         //}
    }

    toggleVerificationRequirement = (isRequired) => {
        let selectedStep = this.props.selectedStep
        selectedStep.requiresVerification = isRequired
        let steps = this.props.updateStep(selectedStep)
        this.props.updateSteps(steps, selectedStep);
    }

    toggleOversightRequirement = (isRequired) => {
        let selectedStep = this.props.selectedStep
        selectedStep.requiresOversight = isRequired
        let steps = this.props.updateStep(selectedStep)
        this.props.updateSteps(steps, selectedStep);
    }

    submitStepEstimationEdit = (estimation) => {
        let updatedStep = this.props.selectedStep
        updatedStep.timeEstimation = estimation
        this.props.updateStep(updatedStep)
       // this.setState({ editingTime: false })
       this.props.toggleEditingTime(false)
    }

    submitStepNameEdit = (e, stepName) => {
        e.preventDefault()
        let updatedStep = this.props.selectedStep
        updatedStep.title = stepName
        let steps = this.props.updateStep(updatedStep)
        this.props.updateSteps(steps, updatedStep)
        this.props.finishStepTitleEdit()
    }

    parseTimeObject = ({days, minutes, hours}) => {
        return `${days ? `${days}d`: '0d'} ${hours ? `${hours}h` : "0h"} ${minutes ? `${minutes}m` : '0m'}`
    }

    renderAttachmentLibraryIcon = (attachments) => {
        let length = attachments.length
        let attachmentsList = attachments.map(attachment => {
            return <li key={`${attachment._id}`}>{attachment.path}</li>
        })
            //this.setState({editingTime:false})
           // this.props.toggleEditingTime(false)
        let tooltipText = length ? <ul>
            <p className="underline">Current Attachments</p>
            {attachmentsList}
        </ul>
         : "Open Attachment Library"
        return addAttachmentIcon(length, this.props.toggleAttachments, tooltipText, this.props.fromPreview,this.props.displayAttachments) 
    }

    returnAttachmentLength =() =>{
            let array = this.props.selectedStep ? this.props.selectedStep.attachments : [];
            return array.length

    }

    renderModelAnnotationIcon = () =>{
        if(!this.props.fromPreview){
            console.log("steptoolbar not in preview")
            let attachments = this.props.selectedStep.attachments 
            if(attachments.length > 0)  { 
                let anno_array = [];
                let count = 1;     
                const currentAttachment = attachments[this.props.attachmentIndex || 0]       
                const filename = this.props.viewingAttachment || currentAttachment ? currentAttachment.path : ""       
                let ext = findExtension(filename);
                let typeModel = isModel(ext)   
                
                if (typeModel){
                    console.log("steptoolbar attachment selected is a model")

                    this.setState({modelAnnotationButtonDisabled: false})
                    this.props.toggleEditingTime(false)
                    let display = document.getElementsByClassName("model-canvas")
                    {display.count!= 0? display[0].addEventListener("click",this.checkisModelAnnotationLoaded): console.log("Unable to set click listener for webgl")}
                }
                else{
                    console.log("steptoolbar attachment selected not model")
                    if(this.props.toggleAnnotation) {this.props.updateToggleAnnotation(false);}
                    this.setState({modelAnnotationButtonDisabled: true})
                }
            }  
            else{
                console.log("steptoolbar attachments length 0")
               if(this.props.toggleAnnotation) {this.props.updateToggleAnnotation(false);}
                this.setState({modelAnnotationButtonDisabled: true})
            }
        }

    }
    
    renderStepAlertsIcon = () => {
        let infoPage = this.props.infoPage
        let numStepAlerts = 0
        let infoList = []
        if (infoPage) {
            let infoItems = Object.keys(infoPage)
            let currentItems = {}
            infoItems.forEach(item => {
                let currentStep = this.props.selectedStep;
                let currentStepId = currentStep ? currentStep._id : 0
                let testItem = infoPage[item];
                testItem.steps.forEach(stepId => {
                    let isGlobal = testItem.global
                    let isIncluded = stepId === currentStepId 
                    if (isGlobal || isIncluded) {                        
                        if (currentItems[item]) {
                            currentItems[item].push(currentStep)
                        } else {
                            currentItems[item] = [currentStep]
                        }
                    }
                })
            })

            numStepAlerts = Object.keys(currentItems).length
            infoList = Object.keys(currentItems).map(item => (<li key={`${item}`}> - {item}</li>))
        }
        if (!this.props.fromPreview){
            // this.props.updateToggleAnnotation(false)
        }
        let tooltipText = numStepAlerts ? 
                <ul>
                    <p className="underline">Current Alerts</p>
                    {infoList}
                </ul>
            : "Edit Step Alerts";
            if (this.props.fromPreview) {
                return countStepAlerts(numStepAlerts, this.props.toggleStepAlerts, this.props.displayingAlerts,this.props.fromPreview)
            }
            return this.props.editingStepAlerts ? 
                closeStepAlertsIcon(numStepAlerts, this.props.toggleStepAlerts, tooltipText,this.props.fromPreview): 
                openStepAlertsIcon(numStepAlerts, this.props.toggleStepAlerts, tooltipText,this.props.fromPreview)
    }

    render() {
        const selectedStep = this.props.selectedStep
        const navigationSteps = this.props.navigationSteps

        const { title, attachments, timeEstimation, requiresVerification, requiresOversight} = selectedStep      
        let fromPreview = this.props.fromPreview

        return <div id={fromPreview ? "step-actions-toolbar-container-preview" : "step-actions-toolbar-container"} className={fromPreview ? "" :"flex max-width"}>
            {/* {this.props.editingStepTitle && !fromPreview ? 
                <EditStepNameFieldContainer 
                    stepTitle={selectedStep.title} 
                    submitStepNameEdit={this.submitStepNameEdit}
                    cancel={this.props.finishStepTitleEdit}
                /> : null}  */}
            <Fragment>
             {/* <div id={fromPreview ? "step-actions-step-title-preview" : "step-actions-step-title" }  className ={fromPreview ? "flex-align preview-title" : "flex-align" }> 
            
                    {selectedStep && !this.props.editingStepTitle && !fromPreview?
                        <Fragment>
                            {stepNameField(title ? title : "Name Your Step", this.props.editStepTitle, "Edit Step Title")}
                        </Fragment> : null}
                        {/* {fromPreview ? <p style={{ padding: ".5em" }}>{title}</p> : null} }
                        
             </div> */}
               <div id={fromPreview? "step-actions-icons-preview-div " : "step-actions-icons"} style={{width:"100%",height:"100%"}} className="flex-WI-ToolBars align clickable" >  
              {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ? 
                        <div className="step-action-icon-container leftWhiteBorder"  style={this.props.displayingContent? {background:"white" }: {background:"none"}}>{stepContentIcon(this.props.displayingContent, this.props.toggleStepContent,fromPreview)} </div>
                        :
                        stepContentIcon(this.props.displayingContent, this.props.toggleStepContent,fromPreview)}
              {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ?
                        <div  className="step-action-icon-container leftWhiteBorder" style={this.props.displayingAlerts? {background:"white" }: {background:"none"}}>{this.renderStepAlertsIcon() }</div>
                        :   
                       this.renderStepAlertsIcon() } 
              {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ?
                        <div className="step-action-icon-container leftWhiteBorder"  style={this.props.displayAttachments ? {background:"white" }: {background:"none"}}>{this.renderAttachmentLibraryIcon(selectedStep ? attachments : []) }</div>
                        :   
                        this.renderAttachmentLibraryIcon(selectedStep ? attachments : []) } 
              {/* /////////////////////////////////////////////////////////// */}
              {/* {!fromPreview ? 
                    <div className="step-action-icon-container leftWhiteBorder"  style={this.props.editingTime ? { position: "relative" } : {}}>
                        {this.props.editingTime ? 
                            <Fragment>
                                <TimeEstimations submitStepEstimationEdit={this.submitStepEstimationEdit} cancel={() => this.props.toggleEditingTime(false)} time={timeEstimation} toggleEditingTime={this.props.toggleEditingTime} /> 
                                {timeEstimationNoToolTip(this.parseTimeObject(timeEstimation), () => this.props.toggleEditingTime(false), "time-estimation")}
                            </Fragment>
                        :
                             timeEstimationIcon(selectedStep ? this.parseTimeObject(timeEstimation) : 0, () => this.props.toggleEditingTime(true),"time-estimation") 
                        }               
                    </div>    
                       : null} */}
                    { !fromPreview ? 
                        requiresVerification ? 
                            requireVerification(() => this.toggleVerificationRequirement(false))
                                : 
                            noVerification(() => this.toggleVerificationRequirement(true)) 
                        : null }

                    {!fromPreview ?
                        requiresOversight ?
                            requiresOversightIcon(() => this.toggleOversightRequirement(false))
                                :
                            noOversight(() => this.toggleOversightRequirement(true))
                        : null}

                    {!fromPreview? 
                    <ModelAnnotationButton
                    toggleAnnotation = {this.props.toggleAnnotation}
                    updateToggleAnnotation ={this.props.updateToggleAnnotation}
                    isDisabled ={this.state.modelAnnotationButtonDisabled}
                    />
                    :null}
                    {fromPreview ? 
                        <div className="step-action-icon-container leftWhiteBorder" style={this.props.displayingTOC ? {background:"white" }: {background:"none"}}>{tocToggleIcon(this.props.toggleTOC, this.props.displayingTOC,fromPreview)}</div>
                        :
                        null}

                    {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ?                       
                       this.props.currentStepIndex ? <div className="step-action-icon-container leftWhiteBorder" style={{background:"none"}}> {AttachmentArrowLeftNav(() => this.props.moveStep(this.props.currentStepIndex - 1),true)}</div>  : <div className="step-action-icon-container leftWhiteBorder" style={{background:"none"}}> {AttachmentArrowLeftDisabledNav(true) }</div>                 
                    :null}
                    {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ?                                          
                        this.props.currentStepIndex < this.props.flatSteps.length - 1 ? <div className="step-action-icon-container leftWhiteBorder"  style={{background:"none"}}> {AttachmentArrowRightNav(() => this.props.moveStep(this.props.currentStepIndex + 1),true)}</div> : null
                    :null}
                    {/* /////////////////////////////////////////////////////////// */}
                    {fromPreview ?                       
                        this.props.currentStepIndex === this.props.flatSteps.length - 1 ? <div className="step-action-icon-container leftWhiteBorder" disabled style={{background:"grey"}}> {AttachmentArrowRightNav(() => console.log("end of preview"),true)}</div> : null
                    :null}
                    {/* ///////////////////////////////////////////////////////////{finishTask(this.props.exitPreview)} */}
                </div>
                       {/* //  <NavigationButtons 
                        //  flatSteps={this.props.flatSteps} 
                        //  fromPreview = {true}
                        //  currentStepIndex={this.props.currentStepIndex}
                        //  moveStep={this.props.moveStep}    
                        //  exitPreview={() => this.props.history.goBack()}
                       //  />  */}
            </Fragment>
        </div>
    }
}

export default StepActionsToolbar